import React, { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, Polyline, Marker, Popup, useMap, Polygon } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import logoFederacao from "./assets/logo-ftp.png";
import ptFlag from "./assets/pt.svg";
import gbFlag from "./assets/gb.svg";

// Força o Leaflet a recalcular o tamanho do mapa quando a sidebar muda
function ForceMapResize({ trigger }) {
  const map = useMap();
  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 350); // espera a animação da sidebar
  }, [trigger, map]);
  return null;
}

// Exemplo de bounds para zona de transição (ajuste conforme necessário)
const boundsTransicao = [
  [37.952312, -8.8639313],
  [37.9523254, -8.8638466],
  [37.9524791, -8.8639057],
  [37.9526769, -8.8640083],
  [37.9528302, -8.8641071],
  [37.9528832, -8.8641449],
  [37.9528481, -8.8642193],
  [37.9527463, -8.864151],
  [37.9526658, -8.8640982],
  [37.9525701, -8.864047],
  [37.9525109, -8.8640132],
  [37.9524456, -8.8639878],
  [37.952312, -8.8639313],
];

const boundsTransicao2 = [
  [38.0613105, -8.7822867],
  [38.0613465, -8.7823448],
  [38.0605379, -8.7831217],
  [38.0604985, -8.7830566],
  [38.0613105, -8.7822867],
];

const boundsMeta = [
  [38.0605994, -8.7827282],
  [38.0605803, -8.7827223],
  [38.0605941, -8.7826582],
  [38.0606145, -8.7826658],
  [38.0605994, -8.7827282],
];

// Configuração da Prova - DEFINA MANUALMENTE conforme sua prova
const configProva = {
  natacao: {
    numVoltas: 1,              // Número de voltas
    temVoltas: false,          // Se tem voltas ou é apenas linha reta
    distanciaPorVolta: 0,      // Não relevante para natação
    pontosVolta: []            // Não relevante para natação
  },
  ciclismo: {
    numVoltas: 1,              // Defina: quantas voltas tem o ciclismo
    temVoltas: false,           // Defina: true se tem voltas, false se é linha reta
    distanciaPorVolta: 0,   // Defina: quantos metros tem cada volta (ex: 5km)
    pontosVolta: []        // Defina: onde completa cada volta (ex: aos 5000m = volta 2)
  },
  corrida: {
    numVoltas: 2,              // Defina: quantas voltas tem a corrida
    temVoltas: true,           // Defina: true se tem voltas, false se é linha reta
    distanciaPorVolta: 2500,   // Defina: quantos metros tem cada volta (ex: 1km)
    pontosVolta: [2390]  // Defina: onde completa cada volta (ex: aos 1000m = volta 2, aos 2000m = volta 3)
  }
};

/* 
EXEMPLOS DE CONFIGURAÇÃO MANUAL:

// Para Sprint (sem voltas):
configProva.ciclismo = { numVoltas: 1, temVoltas: false, distanciaPorVolta: 0, pontosVolta: [] };
configProva.corrida = { numVoltas: 1, temVoltas: false, distanciaPorVolta: 0, pontosVolta: [] };

// Para prova com 4 voltas de corrida de 1km cada:
configProva.corrida = { numVoltas: 4, temVoltas: true, distanciaPorVolta: 1000, pontosVolta: [1000, 2000, 3000] };

// Para prova com 3 voltas de ciclismo de 8km cada:
configProva.ciclismo = { numVoltas: 3, temVoltas: true, distanciaPorVolta: 8000, pontosVolta: [8000, 16000] };
*/

// Animação clean: pulsar suave e bandeira redonda
const flagAnimStyle = `
@keyframes flag-pulse {
  0% { box-shadow: 0 0 0 0 rgba(7,133,105,0.15); transform: scale(1); }
  50% { box-shadow: 0 0 0 6px rgba(7,133,105,0.10); transform: scale(1.06); }
  100% { box-shadow: 0 0 0 0 rgba(7,133,105,0.15); transform: scale(1); }
}
`;

// Tradução dos nomes dos segmentos PT->EN
const segmentNames = {
  PT: {
    Natação: "Natação",
    Ciclismo: "Ciclismo",
    Corrida: "Corrida"
  },
  EN: {
    Natação: "Swim",
    Ciclismo: "Bike",
    Corrida: "Run"
  }
};


// Traduções PT/EN
const translations = {
  PT: {
    athletes: "Atletas",
    searchBib: "Pesquisar dorsal",
    focus: "Focar",
    notFound: "Atleta não encontrado",
    statusUnknown: "Status desconhecido",
    statusDSQ: "Atleta desclassificado",
    statusDNF: "Atleta não terminou",
    statusDNS: "Atleta não partiu",
    prova: "Prova",
    lap: "Volta",
    team: "Equipa",
    finishTime: "Hora estimada de término",
    completedRace: "Concluiu a Prova",
    segment: "Segmento",
    avgSpeed: "Velocidade média",
    transition: "Transição",
    finish: "Meta",
    ftp: "Federação de Triatlo de Portugal",
    disclaimerTitle: "Aviso Importante",
    disclaimerText: "A posição apresentada é apenas uma estimativa e o site encontra-se em constante desenvolvimento. Para sugestões de melhorias e reports de bugs: vasco.santos@federacao-triatlo.pt",
    closeDisclaimer: "Entendi"
  },
  EN: {
    athletes: "Athletes",
    searchBib: "Search bib",
    focus: "Focus",
    notFound: "Athlete not found",
    statusUnknown: "Unknown status",
    statusDSQ: "Disqualified athlete",
    statusDNF: "Did not finish",
    statusDNS: "Did not start",
    prova: "Event",
    lap: "Lap",
    team: "Team",
    finishTime: "Estimated finish time",
    completedRace: "Race Completed",
    segment: "Segment",
    avgSpeed: "Average speed",
    transition: "Transition",
    finish: "Finish",
    ftp: "Portuguese Triathlon Federation",
    disclaimerTitle: "Important Notice",
    disclaimerText: "The position shown is only an estimate and the site is in constant development. For improvement suggestions and bug reports: vasco.santos@federacao-triatlo.pt",
    closeDisclaimer: "I understand"
  }
};

let serverNow = Date.now(); // valor default

function FlyToAtleta({ pos }) {
  const map = useMap();
  useEffect(() => {
    if (pos) {
      map.flyTo(pos, 17, { duration: 1.5 });
    }
  }, [pos, map]);
  return null;
}

const natacao = [
  [37.9540176, -8.8704576],
  [37.9516364, -8.8700387],
  [37.9510304, -8.8677327],
  [37.9523375, -8.8646468],
  [37.9525249, -8.8642739],
  [37.9525809, -8.8641469],
  [37.9525635, -8.8640932],
  [37.952466, -8.8640377],
  [37.9523312, -8.8639859],
  [37.9522745, -8.8639533],
  [37.9522786, -8.8639051],
  [37.9523181, -8.8638871],
];
const ciclismo = [
  [37.9528922, -8.8641984],
  [37.9530092, -8.864303],
  [37.9531499, -8.8644544],
  [37.9532683, -8.8646141],
  [37.9533996, -8.8646811],
  [37.9534541, -8.8646988],
  [37.953585, -8.8648748],
  [37.9536388, -8.8649635],
  [37.9538313, -8.8653027],
  [37.9540098, -8.8656475],
  [37.9541507, -8.8659825],
  [37.9542394, -8.8663055],
  [37.9542767, -8.8665737],
  [37.9543251, -8.8668796],
  [37.9543518, -8.867119],
  [37.9543773, -8.8676332],
  [37.9543853, -8.8680452],
  [37.9543998, -8.8684112],
  [37.9544286, -8.8693981],
  [37.9544638, -8.8702782],
  [37.9544586, -8.8705136],
  [37.9544549, -8.8707276],
  [37.9544224, -8.8709942],
  [37.9543746, -8.8712031],
  [37.9543039, -8.8714435],
  [37.9542539, -8.8715695],
  [37.9541199, -8.8718484],
  [37.9540073, -8.872023],
  [37.9538927, -8.8721736],
  [37.952759, -8.8734179],
  [37.9518917, -8.8743381],
  [37.951518, -8.8747788],
  [37.95138, -8.8750071],
  [37.9512264, -8.8753019],
  [37.9511199, -8.8755798],
  [37.9510267, -8.8760458],
  [37.9510173, -8.8764546],
  [37.9510967, -8.8769833],
  [37.9512123, -8.8773357],
  [37.951423, -8.877733],
  [37.9515787, -8.8779215],
  [37.951735, -8.8780629],
  [37.9520871, -8.8783919],
  [37.9526536, -8.878895],
  [37.9529768, -8.8791993],
  [37.9531706, -8.8794202],
  [37.9534384, -8.8797832],
  [37.9537059, -8.8802466],
  [37.9539319, -8.8807447],
  [37.954587, -8.8821239],
  [37.9548048, -8.8825332],
  [37.9552684, -8.8832774],
  [37.955793, -8.8839327],
  [37.9562058, -8.8843522],
  [37.9566534, -8.8846719],
  [37.9570546, -8.8848827],
  [37.9574181, -8.8850059],
  [37.957761, -8.885088],
  [37.9580834, -8.8851269],
  [37.9583869, -8.8851392],
  [37.9586279, -8.885131],
  [37.958893, -8.8850997],
  [37.9591958, -8.8850429],
  [37.9593815, -8.8849986],
  [37.9594767, -8.8849653],
  [37.9598132, -8.8848493],
  [37.960314, -8.8846028],
  [37.9606611, -8.8844227],
  [37.9611494, -8.8840778],
  [37.9613331, -8.8839292],
  [37.9615397, -8.8837559],
  [37.9617702, -8.8835611],
  [37.9620547, -8.8832714],
  [37.9623144, -8.8829842],
  [37.9625873, -8.882666],
  [37.9629563, -8.8821738],
  [37.9632246, -8.881781],
  [37.9635449, -8.8812735],
  [37.9637862, -8.8808492],
  [37.964142, -8.8801638],
  [37.9644012, -8.8796129],
  [37.9646697, -8.8790463],
  [37.964821, -8.8786624],
  [37.9649567, -8.8782701],
  [37.9651771, -8.8776953],
  [37.9654331, -8.8769858],
  [37.9656001, -8.8764721],
  [37.9657867, -8.8758548],
  [37.9659178, -8.8753442],
  [37.9660044, -8.8749145],
  [37.9660747, -8.8745294],
  [37.9661529, -8.8741188],
  [37.9661992, -8.8736709],
  [37.966247, -8.873089],
  [37.9662558, -8.872474],
  [37.966226, -8.8718653],
  [37.9660114, -8.8706247],
  [37.9658993, -8.8704902],
  [37.9657977, -8.870404],
  [37.965721, -8.8702181],
  [37.9657633, -8.8700562],
  [37.9657591, -8.8698399],
  [37.9656637, -8.8695748],
  [37.9655148, -8.8692302],
  [37.9653056, -8.8688266],
  [37.9650863, -8.8684582],
  [37.964831, -8.8680693],
  [37.9644963, -8.8676381],
  [37.9640788, -8.8671416],
  [37.9634472, -8.8663466],
  [37.9631971, -8.8660082],
  [37.9630026, -8.8656827],
  [37.9626829, -8.865095],
  [37.9624921, -8.8646269],
  [37.9622757, -8.8639935],
  [37.9620592, -8.8631411],
  [37.9620016, -8.86265],
  [37.9619497, -8.8620135],
  [37.9619341, -8.8614949],
  [37.9619606, -8.8609903],
  [37.961999, -8.8605154],
  [37.9620715, -8.8600769],
  [37.9622219, -8.8593707],
  [37.9623636, -8.8589212],
  [37.9624854, -8.8585739],
  [37.9626846, -8.8581059],
  [37.9629017, -8.8576782],
  [37.9631812, -8.8572008],
  [37.963378, -8.8569064],
  [37.9636128, -8.8565916],
  [37.9639231, -8.8562283],
  [37.964361, -8.8557204],
  [37.9648002, -8.855196],
  [37.9650878, -8.8548309],
  [37.9653188, -8.8544978],
  [37.9655629, -8.8541087],
  [37.9655893, -8.8538549],
  [37.9656347, -8.8536594],
  [37.9657666, -8.8535445],
  [37.9659034, -8.8535646],
  [37.9659939, -8.8536643],
  [37.9660394, -8.8538878],
  [37.9660939, -8.8540814],
  [37.9661422, -8.8542437],
  [37.9661628, -8.854479],
  [37.9661256, -8.8547733],
  [37.9661148, -8.8549974],
  [37.9660985, -8.8553589],
  [37.966136, -8.8556302],
  [37.9661746, -8.8557545],
  [37.9662184, -8.8558331],
  [37.9662639, -8.8558863],
  [37.9663276, -8.8558861],
  [37.9664196, -8.8558465],
  [37.9665081, -8.8557751],
  [37.9667932, -8.8555196],
  [37.9669509, -8.8553609],
  [37.9674234, -8.8548882],
  [37.9683408, -8.8539581],
  [37.9687964, -8.8534863],
  [37.9689846, -8.8533025],
  [37.9690918, -8.8532136],
  [37.9692529, -8.8531013],
  [37.9693856, -8.8530335],
  [37.9697206, -8.8529171],
  [37.9709518, -8.8524846],
  [37.9716161, -8.8522423],
  [37.9717245, -8.8521898],
  [37.9718708, -8.8520974],
  [37.9719635, -8.8520092],
  [37.9722654, -8.8516813],
  [37.9723935, -8.8515441],
  [37.9728472, -8.8510385],
  [37.9730521, -8.850809],
  [37.9732926, -8.850517],
  [37.9736489, -8.8500157],
  [37.9738383, -8.8497401],
  [37.974038, -8.8494592],
  [37.974149, -8.8492314],
  [37.9742837, -8.8488061],
  [37.974769, -8.8471371],
  [37.9750235, -8.8462403],
  [37.9750774, -8.8460846],
  [37.9751351, -8.8459349],
  [37.9752261, -8.8457633],
  [37.97536, -8.8455543],
  [37.9754761, -8.845425],
  [37.9756205, -8.8452908],
  [37.9759944, -8.8449752],
  [37.9761033, -8.8448531],
  [37.9761974, -8.8446785],
  [37.9763017, -8.8444101],
  [37.9768281, -8.8427001],
  [37.976944, -8.8422936],
  [37.976996, -8.842151],
  [37.9770599, -8.8420292],
  [37.9771629, -8.8418989],
  [37.9773007, -8.8418003],
  [37.9774502, -8.8417229],
  [37.9776779, -8.8416119],
  [37.9780954, -8.8414094],
  [37.9781979, -8.8413966],
  [37.9784799, -8.8413786],
  [37.9785843, -8.8413537],
  [37.9787175, -8.8413116],
  [37.978975, -8.8411977],
  [37.9793842, -8.841003],
  [37.9796188, -8.8409241],
  [37.9798164, -8.8408696],
  [37.9801669, -8.840795],
  [37.9806091, -8.8407317],
  [37.9807819, -8.840698],
  [37.980924, -8.8406519],
  [37.9810556, -8.8405848],
  [37.9811954, -8.8404615],
  [37.9813615, -8.840306],
  [37.9814819, -8.8402014],
  [37.9815911, -8.8401673],
  [37.9817694, -8.8401815],
  [37.9818757, -8.8401728],
  [37.9820678, -8.8400952],
  [37.9826821, -8.8397845],
  [37.9833119, -8.8394272],
  [37.9835297, -8.8393028],
  [37.9836528, -8.8392485],
  [37.9838367, -8.839186],
  [37.984445, -8.8389791],
  [37.9845934, -8.8389241],
  [37.9847038, -8.8388803],
  [37.9848674, -8.8388199],
  [37.9850266, -8.8387577],
  [37.9851645, -8.8387316],
  [37.9853103, -8.8387178],
  [37.9856216, -8.8387029],
  [37.986093, -8.8387247],
  [37.9869139, -8.8387587],
  [37.9883595, -8.8388177],
  [37.9884766, -8.838815],
  [37.9886401, -8.8387883],
  [37.9887753, -8.8387482],
  [37.9889147, -8.8386908],
  [37.9890527, -8.8386201],
  [37.9891969, -8.838504],
  [37.9893573, -8.8383424],
  [37.9894875, -8.8381459],
  [37.9895916, -8.8379257],
  [37.9896992, -8.8375896],
  [37.9897337, -8.8373686],
  [37.9897452, -8.8370014],
  [37.9897499, -8.8339897],
  [37.9898813, -8.833126],
  [37.9899071, -8.8312778],
  [37.9899136, -8.8307824],
  [37.9899941, -8.8307302],
  [37.9900884, -8.8307286],
  [37.9901691, -8.8307846],
  [37.9903254, -8.8310243],
  [37.9904602, -8.8313053],
  [37.9906441, -8.8315832],
  [37.9907799, -8.8317686],
  [37.9909296, -8.8319399],
  [37.9911304, -8.83214],
  [37.9913871, -8.8324258],
  [37.9916098, -8.8327392],
  [37.9917859, -8.8330145],
  [37.992001, -8.8332375],
  [37.9922069, -8.8333756],
  [37.9923982, -8.8334297],
  [37.9926198, -8.8334332],
  [37.9936333, -8.83325],
  [37.994469, -8.8330318],
  [37.9950646, -8.8328478],
  [37.9955242, -8.8326851],
  [37.9963188, -8.8323623],
  [37.9967099, -8.832173],
  [37.9977787, -8.8316266],
  [37.9987264, -8.8310886],
  [37.9999393, -8.830342],
  [38.0002448, -8.8301403],
  [38.0005139, -8.8299532],
  [38.0009599, -8.8296423],
  [38.0016983, -8.8291302],
  [38.002237, -8.8287401],
  [38.002523, -8.8285451],
  [38.0027925, -8.8283561],
  [38.003487, -8.827877],
  [38.0043761, -8.8272553],
  [38.0051606, -8.8267433],
  [38.0056102, -8.8264243],
  [38.0064283, -8.8258424],
  [38.0067673, -8.825595],
  [38.0071568, -8.8253048],
  [38.0079811, -8.8247039],
  [38.0085633, -8.8243117],
  [38.0090908, -8.8239417],
  [38.0094779, -8.8236531],
  [38.0097606, -8.8234385],
  [38.0102729, -8.8230511],
  [38.0106576, -8.8227447],
  [38.0113402, -8.8221829],
  [38.0118828, -8.8216973],
  [38.0122787, -8.8213437],
  [38.0129781, -8.8206891],
  [38.0133038, -8.8204011],
  [38.0137137, -8.8200505],
  [38.0141619, -8.8196645],
  [38.0148965, -8.8190711],
  [38.0152751, -8.8187675],
  [38.0155442, -8.8185481],
  [38.0158041, -8.8183674],
  [38.0164983, -8.8179225],
  [38.0169244, -8.8176815],
  [38.0175292, -8.8173225],
  [38.0179447, -8.8170808],
  [38.0188179, -8.816574],
  [38.0197575, -8.8160278],
  [38.0200248, -8.8158708],
  [38.0208947, -8.8153684],
  [38.0215199, -8.8150095],
  [38.0221864, -8.8146016],
  [38.0225083, -8.814381],
  [38.0227033, -8.8142619],
  [38.0229039, -8.8141202],
  [38.0232797, -8.8138349],
  [38.0234915, -8.8136643],
  [38.0237888, -8.8134145],
  [38.0241928, -8.8130458],
  [38.0243738, -8.8128792],
  [38.0247496, -8.8125146],
  [38.0250618, -8.8122156],
  [38.0252913, -8.812007],
  [38.0256047, -8.8117241],
  [38.0259109, -8.8114624],
  [38.0265446, -8.8109137],
  [38.0268691, -8.810626],
  [38.0272232, -8.8103276],
  [38.0275685, -8.810058],
  [38.0279129, -8.8097899],
  [38.0281217, -8.8096403],
  [38.0284141, -8.8094325],
  [38.0289858, -8.8090181],
  [38.0295154, -8.808646],
  [38.0301205, -8.8081959],
  [38.0305011, -8.8079267],
  [38.0308985, -8.8076115],
  [38.0312768, -8.8073132],
  [38.0315537, -8.8070613],
  [38.0319961, -8.8066495],
  [38.0322724, -8.8063863],
  [38.0327808, -8.8059156],
  [38.0330784, -8.8056378],
  [38.0338085, -8.804945],
  [38.0347054, -8.8041009],
  [38.0354144, -8.8034453],
  [38.0363085, -8.8025991],
  [38.0368884, -8.8020407],
  [38.0372964, -8.8016315],
  [38.0376653, -8.8012845],
  [38.037816, -8.8011074],
  [38.0378855, -8.8009105],
  [38.0378835, -8.8006128],
  [38.0378033, -8.8000678],
  [38.0378805, -8.7998451],
  [38.0379593, -8.7997021],
  [38.0379841, -8.7995156],
  [38.0380801, -8.7994152],
  [38.038178, -8.7994128],
  [38.0383084, -8.79936],
  [38.038524, -8.7991522],
  [38.0386836, -8.799069],
  [38.0388459, -8.7990446],
  [38.0389873, -8.7990877],
  [38.0391957, -8.799223],
  [38.0393458, -8.7993174],
  [38.0394565, -8.7993812],
  [38.0396158, -8.7994198],
  [38.03974, -8.7994249],
  [38.0398724, -8.7994023],
  [38.0399918, -8.7993506],
  [38.0402184, -8.7991784],
  [38.0403469, -8.7990646],
  [38.0406082, -8.7988277],
  [38.0408112, -8.7986529],
  [38.0410895, -8.7983987],
  [38.0414428, -8.7980726],
  [38.0419892, -8.7975663],
  [38.0425565, -8.7970538],
  [38.0428964, -8.7967615],
  [38.0432114, -8.7964931],
  [38.0437997, -8.7960203],
  [38.0443421, -8.7956137],
  [38.0447404, -8.7953212],
  [38.0451478, -8.7950378],
  [38.0453797, -8.79488],
  [38.0456162, -8.7947233],
  [38.0460203, -8.7944573],
  [38.0463983, -8.7942322],
  [38.0468408, -8.7939724],
  [38.0471265, -8.7938198],
  [38.0475645, -8.7935674],
  [38.0479528, -8.7933515],
  [38.0485841, -8.792998],
  [38.0488319, -8.7928718],
  [38.0493706, -8.7925628],
  [38.0497548, -8.7923482],
  [38.0502779, -8.7920653],
  [38.0505895, -8.7918965],
  [38.0513401, -8.7914754],
  [38.0520819, -8.791096],
  [38.052864, -8.7906761],
  [38.0530779, -8.7905712],
  [38.0532847, -8.7904559],
  [38.0537015, -8.7903231],
  [38.0541994, -8.7901636],
  [38.0546719, -8.7900346],
  [38.0551286, -8.7899391],
  [38.0556491, -8.7898691],
  [38.0560453, -8.7898329],
  [38.056343, -8.789811],
  [38.0568989, -8.7897616],
  [38.0571773, -8.789731],
  [38.0574129, -8.7896989],
  [38.0576926, -8.7896585],
  [38.0580332, -8.7895887],
  [38.058309, -8.7895284],
  [38.0586159, -8.7894403],
  [38.0588644, -8.7893669],
  [38.0591219, -8.7892761],
  [38.0593495, -8.7891915],
  [38.0599347, -8.7889145],
  [38.0603117, -8.7887107],
  [38.060856, -8.7883716],
  [38.0612788, -8.7880929],
  [38.0618075, -8.7877263],
  [38.0621225, -8.7875084],
  [38.0625876, -8.7871896],
  [38.0628847, -8.7869969],
  [38.0632106, -8.7867574],
  [38.0636844, -8.7864483],
  [38.0644534, -8.7859143],
  [38.065247, -8.7853704],
  [38.0655204, -8.785183],
  [38.0659269, -8.7848971],
  [38.0662421, -8.7847007],
  [38.0667821, -8.7843483],
  [38.0671211, -8.7841489],
  [38.0677469, -8.7838231],
  [38.0680417, -8.7836743],
  [38.0682448, -8.7835843],
  [38.0683785, -8.7835098],
  [38.0684921, -8.7833801],
  [38.068627, -8.7832564],
  [38.0687291, -8.7832206],
  [38.0688747, -8.7831447],
  [38.0689521, -8.783069],
  [38.0689835, -8.782987],
  [38.068981, -8.782899],
  [38.0689367, -8.7828282],
  [38.0688478, -8.7828058],
  [38.0686862, -8.7828796],
  [38.0686087, -8.7829361],
  [38.0682504, -8.7831341],
  [38.0679846, -8.7832526],
  [38.067836, -8.7832785],
  [38.0676727, -8.7832266],
  [38.0675291, -8.7831449],
  [38.0674209, -8.783028],
  [38.0673388, -8.7828765],
  [38.0670855, -8.7817755],
  [38.0665441, -8.7793053],
  [38.0664591, -8.7789187],
  [38.0664053, -8.7787904],
  [38.0663404, -8.7787255],
  [38.0662254, -8.7787081],
  [38.0660579, -8.7787496],
  [38.0657638, -8.7788758],
  [38.0652673, -8.7790459],
  [38.0649814, -8.7791624],
  [38.0648345, -8.77922],
  [38.064705, -8.779289],
  [38.0645607, -8.7793883],
  [38.0642998, -8.779596],
  [38.064199, -8.7796862],
  [38.0641568, -8.7797952],
  [38.0641077, -8.7798736],
  [38.0640225, -8.7799135],
  [38.0639274, -8.7799133],
  [38.0638331, -8.7799563],
  [38.0637686, -8.7800056],
  [38.0636889, -8.7800867],
  [38.0632607, -8.7805057],
  [38.0626836, -8.7810633],
  [38.0619463, -8.7817643],
  [38.0618227, -8.781899],
  [38.061791, -8.7819987],
  [38.0617613, -8.7820912],
  [38.0616782, -8.7821407],
  [38.0615784, -8.7821613],
  [38.0615086, -8.7821977],
  [38.061426, -8.7822456],
  [38.0613526, -8.7823098],
];

const corrida = [
  [38.0605193, -8.7830958],
  [38.0602169, -8.7833831],
  [38.059598, -8.7839571],
  [38.059101, -8.7843646],
  [38.0589444, -8.7844083],
  [38.0588531, -8.7843889],
  [38.0587556, -8.7843141],
  [38.0586351, -8.7840813],
  [38.0579405, -8.7827035],
  [38.0576329, -8.7820823],
  [38.0576354, -8.7820235],
  [38.0576896, -8.7819806],
  [38.057784, -8.7819052],
  [38.0578311, -8.7818475],
  [38.0578197, -8.7817695],
  [38.0577451, -8.7816245],
  [38.0576859, -8.7815059],
  [38.0576495, -8.7814084],
  [38.0576987, -8.781322],
  [38.0578013, -8.7812897],
  [38.0578874, -8.7812764],
  [38.0590669, -8.7808542],
  [38.0596201, -8.780651],
  [38.059969, -8.7805496],
  [38.0600876, -8.7805221],
  [38.0603029, -8.7804987],
  [38.060508, -8.7803094],
  [38.0606584, -8.7801923],
  [38.0607184, -8.7801793],
  [38.0610443, -8.780844],
  [38.0614353, -8.781597],
  [38.0615189, -8.7817186],
  [38.0615707, -8.7817889],
  [38.0616332, -8.7818178],
  [38.0617256, -8.7818289],
  [38.0618051, -8.7818088],
  [38.0619194, -8.7817168],
  [38.0623122, -8.7813485],
  [38.0626745, -8.7809961],
  [38.0635449, -8.7801549],
  [38.0637274, -8.7799652],
  [38.063822, -8.7798504],
  [38.0638895, -8.7796531],
  [38.0639566, -8.7795715],
  [38.0640315, -8.7795586],
  [38.0641171, -8.7795554],
  [38.0642073, -8.7795173],
  [38.0644418, -8.7793274],
  [38.0647638, -8.7791104],
  [38.0651986, -8.7789331],
  [38.0656285, -8.7787867],
  [38.065894, -8.7786935],
  [38.0661181, -8.7785956],
  [38.0661948, -8.7785462],
  [38.0661988, -8.7785442],
  [38.0662036, -8.7785448],
  [38.0662086, -8.7785476],
  [38.0662116, -8.7785521],
  [38.066215, -8.7785566],
  [38.0662176, -8.778562],
  [38.0662211, -8.778572],
  [38.0662223, -8.7785794],
  [38.0662202, -8.7785842],
  [38.0662174, -8.778587],
  [38.0657595, -8.7787905],
  [38.0652337, -8.7789825],
  [38.0647845, -8.7791679],
  [38.0645128, -8.7793554],
  [38.0642808, -8.7795144],
  [38.0641406, -8.7795976],
  [38.0640153, -8.7796101],
  [38.0639882, -8.7796132],
  [38.0639645, -8.7796289],
  [38.0639393, -8.7796574],
  [38.0639207, -8.7796931],
  [38.0638532, -8.7798333],
  [38.0638061, -8.7799047],
  [38.0637321, -8.7799947],
  [38.0636466, -8.7800879],
  [38.0634309, -8.7802989],
  [38.0624748, -8.7812207],
  [38.0618296, -8.7818268],
  [38.0617776, -8.7818566],
  [38.0617176, -8.7818662],
  [38.061635, -8.7818838],
  [38.0615592, -8.7819831],
  [38.061516, -8.7820872],
  [38.0614747, -8.782153],
  [38.061419, -8.7822136],
  [38.0613976, -8.7821824],
  [38.0613806, -8.7821737],
  [38.0613425, -8.7821944],
  [38.0608515, -8.7826716],
  [38.0605015, -8.7830024],
  [38.06008, -8.7834149],
  [38.0600733, -8.783468],
  [38.0600711, -8.7835069],
  [38.0600567, -8.7835207],
  [38.059879, -8.7836876],
  [38.0595931, -8.7839471],
  [38.0590996, -8.784348],
  [38.0589499, -8.7843887],
  [38.0588667, -8.7843685],
  [38.0587726, -8.7843023],
  [38.0586485, -8.7840636],
  [38.0579532, -8.7826903],
  [38.0576473, -8.7820763],
  [38.0576473, -8.7820317],
  [38.0576932, -8.7819923],
  [38.0577908, -8.7819179],
  [38.0578465, -8.7818547],
  [38.0578333, -8.7817647],
  [38.0577509, -8.7816096],
  [38.0576962, -8.7814916],
  [38.057666, -8.781413],
  [38.0577078, -8.7813434],
  [38.0578, -8.7813071],
  [38.0578931, -8.7812966],
  [38.0591049, -8.7808713],
  [38.0596803, -8.7806498],
  [38.0599736, -8.7805726],
  [38.0601014, -8.7805454],
  [38.0602893, -8.7805228],
  [38.0603412, -8.7804976],
  [38.0605209, -8.7803325],
  [38.0606617, -8.7802104],
  [38.0607076, -8.7802013],
  [38.06104, -8.7808722],
  [38.0614373, -8.7816311],
  [38.0615242, -8.7817572],
  [38.0615708, -8.7818223],
  [38.0616322, -8.7818481],
  [38.0617264, -8.7818432],
  [38.061802, -8.7818221],
  [38.0619229, -8.7817261],
  [38.0623224, -8.7813532],
  [38.062684, -8.7810048],
  [38.0635518, -8.7801627],
  [38.0637354, -8.7799691],
  [38.0638259, -8.7798535],
  [38.0638671, -8.7797536],
  [38.0638973, -8.7796589],
  [38.0639603, -8.7795809],
  [38.0640362, -8.7795684],
  [38.0641194, -8.7795652],
  [38.06421, -8.7795279],
  [38.064445, -8.7793367],
  [38.0647689, -8.7791178],
  [38.0652001, -8.7789516],
  [38.0658948, -8.7787017],
  [38.066119, -8.7785987],
  [38.066196, -8.7785493],
  [38.0661991, -8.778547],
  [38.0662027, -8.7785471],
  [38.0662072, -8.7785491],
  [38.0662131, -8.7785574],
  [38.0662158, -8.7785631],
  [38.0662192, -8.7785734],
  [38.0662188, -8.77858],
  [38.0662155, -8.7785839],
  [38.0657543, -8.7787758],
  [38.0652345, -8.7789655],
  [38.0647799, -8.77915],
  [38.0642778, -8.7795029],
  [38.0642083, -8.7795455],
  [38.0641365, -8.7795855],
  [38.0640179, -8.7795998],
  [38.0639849, -8.7796065],
  [38.0639607, -8.7796227],
  [38.0639358, -8.7796513],
  [38.0638523, -8.7798231],
  [38.0638302, -8.7798584],
  [38.0638014, -8.7798998],
  [38.0637294, -8.77999],
  [38.0636422, -8.7800816],
  [38.0634265, -8.7802937],
  [38.0628802, -8.7808228],
  [38.062605, -8.7810888],
  [38.0623333, -8.7813483],
  [38.0620773, -8.7815879],
  [38.0618342, -8.7818133],
  [38.0617765, -8.7818477],
  [38.0617161, -8.7818571],
  [38.0616324, -8.781874],
  [38.0615513, -8.7819782],
  [38.0615081, -8.7820802],
  [38.0614663, -8.7821483],
  [38.0614197, -8.7822025],
  [38.0614037, -8.7821774],
  [38.0613834, -8.7821647],
  [38.0613407, -8.7821857],
  [38.060905, -8.7826057],
  [38.0608789, -8.7826302],
  [38.0608581, -8.7826251],
  [38.0608287, -8.7825812],
  [38.060681, -8.782348],
  [38.0606525, -8.7823507],
  [38.0606415, -8.7824216],
  [38.0606345, -8.7824803],
  [38.0606327, -8.7825027],
  [38.0606313, -8.7825205],
  [38.0606262, -8.7825682],
  [38.0606177, -8.7826333],
  [38.0606044, -8.7826657],
];

// Junta todos os pontos para centrar o mapa
const percurso = [...natacao, ...ciclismo, ...corrida];

function getTimestamp(hPassagem, horaGun) {
  // Assume sempre a data do horaGun
  if (typeof hPassagem === "string" && hPassagem.includes(":")) {
    const [gunDate] = horaGun.split(" ");
    const [h, m, s] = hPassagem.split(":").map(Number);
    // Usa a data do horaGun e a hora da passagem
    const d = new Date(`${gunDate}T${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`);
    return d.getTime();
  }
  return new Date(hPassagem).getTime();
}

function dist(a, b) {
  const R = 6371000; // raio da Terra em metros
  const lat1 = a[0] * Math.PI / 180;
  const lat2 = b[0] * Math.PI / 180;
  const dLat = (b[0] - a[0]) * Math.PI / 180;
  const dLon = (b[1] - a[1]) * Math.PI / 180;

  const hav =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(hav), Math.sqrt(1 - hav));
  return R * c;
}

function calcularPosicao(atleta, extraDistancia = 0) {
  // Se o atleta concluiu a prova, retorna a posição da meta (final do percurso de corrida)
  if (atletaConcluiuProva(atleta)) {
    return corrida[corrida.length - 1]; // última posição do percurso de corrida (meta)
  }

  let segmento;
  let distancia = (atleta.distancia_no_segmento || 0) + extraDistancia;

  // Determinar o segmento e calcular a posição linear (sem voltar ao início)
  if (atleta.segmento_nome?.toLowerCase().includes("ciclismo")) {
    const configCiclismo = configProva.ciclismo;
    
    // Verificar se o atleta deve transitar para a corrida
    const distanciaMaximaCiclismo = configCiclismo.numVoltas * configCiclismo.distanciaPorVolta;
    if (distancia > distanciaMaximaCiclismo) {
      // Atleta terminou ciclismo e vai para a corrida
      segmento = corrida;
      distancia = distancia - distanciaMaximaCiclismo;
      
      // Limitar a distância máxima na corrida
      const configCorrida = configProva.corrida;
      const maxDistanciaCorrida = configCorrida.numVoltas * configCorrida.distanciaPorVolta;
      distancia = Math.min(distancia, maxDistanciaCorrida);
    } else {
      // Ainda está no ciclismo
      segmento = ciclismo;
      distancia = Math.min(distancia, distanciaMaximaCiclismo);
    }
  } else if (atleta.segmento_nome?.toLowerCase().includes("corrida")) {
    segmento = corrida;
    const configCorrida = configProva.corrida;
    const maxDistancia = configCorrida.numVoltas * configCorrida.distanciaPorVolta;
    distancia = Math.min(distancia, maxDistancia);
  } else {
    // Natação ou outros segmentos
    segmento = natacao;
  }

  // Se distância é 0, retorna o início do segmento
  if (distancia <= 0) {
    return segmento[0];
  }

  // Calcular comprimento total do segmento
  let comprimentoTotal = 0;
  for (let i = 0; i < segmento.length - 1; i++) {
    comprimentoTotal += dist(segmento[i], segmento[i + 1]);
  }

  // Garantir que a distância não excede o comprimento total do percurso
  distancia = Math.min(distancia, comprimentoTotal);

  // Calcular posição ao longo do percurso
  let distanciaAcumulada = 0;
  for (let i = 0; i < segmento.length - 1; i++) {
    const distanciaSegmento = dist(segmento[i], segmento[i + 1]);
    
    if (distanciaAcumulada + distanciaSegmento >= distancia) {
      // A posição está neste segmento
      const distanciaNoSegmento = distancia - distanciaAcumulada;
      const fracao = distanciaNoSegmento / distanciaSegmento;
      
      return [
        segmento[i][0] + fracao * (segmento[i + 1][0] - segmento[i][0]),
        segmento[i][1] + fracao * (segmento[i + 1][1] - segmento[i][1])
      ];
    }
    
    distanciaAcumulada += distanciaSegmento;
  }

  // Se chegou aqui, está no final do percurso
  return segmento[segmento.length - 1];
}

function getVelocidade(atleta) {
  // Para corrida, usa RunLap1 ou RunLap2 baseado na volta
  if (atleta.segmento_nome?.toLowerCase().includes("corrida")) {
    const volta = getVolta(atleta);
    if (volta === 1 && atleta.RunLap1) {
      return atleta.RunLap1;
    } else if (volta === 2 && atleta.RunLap2) {
      return atleta.RunLap2;
    }
    // Fallback para velocidade_m se RunLap não estiver disponível
    return atleta.velocidade_m || 0;
  }
  
  // Para ciclismo, usa BikeLap1 ou BikeLap2 baseado na volta
  if (atleta.segmento_nome?.toLowerCase().includes("ciclismo")) {
    const volta = getVolta(atleta);
    if (volta === 1 && atleta.BikeLap1) {
      return atleta.BikeLap1;
    } else if (volta === 2 && atleta.BikeLap2) {
      return atleta.BikeLap2;
    }
    // Fallback para velocidade_m se BikeLap não estiver disponível
    return atleta.velocidade_m || 0;
  }
  
  // Para outros segmentos (natação), usa velocidade_m
  return atleta.velocidade_m || 0;
}

function getVolta(atleta) {
  const distancia = (atleta.distancia_no_segmento || 0) + (atleta.extraDistancia || 0);
  
  // Ciclismo - calcula volta baseado na configuração
  if (atleta.segmento_nome?.toLowerCase().includes("ciclismo")) {
    if (!configProva.ciclismo.temVoltas) return 1;
    
    const config = configProva.ciclismo;
    
    // Se não há pontos de volta definidos, usa cálculo por distância
    if (!config.pontosVolta || config.pontosVolta.length === 0) {
      const voltaCalculada = Math.floor(distancia / config.distanciaPorVolta) + 1;
      return Math.min(config.numVoltas, Math.max(1, voltaCalculada));
    }
    
    // Calcula a volta baseada nos pontos de volta definidos na configuração
    let volta = 1;
    for (const pontoVolta of config.pontosVolta) {
      if (distancia >= pontoVolta) {
        volta++;
      } else {
        break;
      }
    }
    return Math.min(config.numVoltas, volta);
  }
  
  // Corrida - calcula volta baseado na configuração
  if (atleta.segmento_nome?.toLowerCase().includes("corrida")) {
    if (!configProva.corrida.temVoltas) return 1;
    
    const config = configProva.corrida;
    
    // Se não há pontos de volta definidos, usa cálculo por distância
    if (!config.pontosVolta || config.pontosVolta.length === 0) {
      const voltaCalculada = Math.floor(distancia / config.distanciaPorVolta) + 1;
      return Math.min(config.numVoltas, Math.max(1, voltaCalculada));
    }
    
    // Calcula a volta baseada nos pontos de volta definidos na configuração
    let volta = 1;
    for (const pontoVolta of config.pontosVolta) {
      if (distancia >= pontoVolta) {
        volta++;
      } else {
        break;
      }
    }
    return Math.min(config.numVoltas, volta);
  }
  
  // Natação e outros segmentos
  return 1;
}

// Função para calcular pontos de KM ao longo de um percurso
function calcularPontosKM(percurso, intervalKm) {
  const pontos = [];
  let distanciaAcumulada = 0;
  let proximoKm = intervalKm * 1000; // converter para metros
  
  for (let i = 0; i < percurso.length - 1; i++) {
    const distanciaSegmento = dist(percurso[i], percurso[i + 1]);
    
    while (proximoKm <= distanciaAcumulada + distanciaSegmento) {
      // Calcular posição do ponto de KM
      const distanciaNoSegmento = proximoKm - distanciaAcumulada;
      const frac = distanciaNoSegmento / distanciaSegmento;
      
      const posicaoKm = [
        percurso[i][0] + frac * (percurso[i + 1][0] - percurso[i][0]),
        percurso[i][1] + frac * (percurso[i + 1][1] - percurso[i][1])
      ];
      
      pontos.push({
        posicao: posicaoKm,
        km: proximoKm / 1000
      });
      
      proximoKm += intervalKm * 1000;
    }
    
    distanciaAcumulada += distanciaSegmento;
  }
  
  return pontos;
}

// Calcular pontos de KM para cada segmento
const pontosKmNatacao = calcularPontosKM(natacao, 0.1); // a cada 0.5km
const pontosKmCiclismo = calcularPontosKM(ciclismo, 1); // a cada 1km
const pontosKmCorrida = calcularPontosKM(corrida, 1); // a cada 1km

// Função para verificar se o atleta concluiu a prova
function atletaConcluiuProva(atleta) {
  // Verifica se o atleta está no segmento "Meta"
  return atleta.segmento_nome && atleta.segmento_nome.toLowerCase().includes("meta");
}

export default function LiveMap() {
  const [atletas, setAtletas] = useState([]);
  const [animados, setAnimados] = useState([]);
  const [horaGun, setHoraGun] = useState("2025-11-02 12:00:00");
  const atletasRef = useRef([]);
  const [searchBib, setSearchBib] = useState("");
  const [focusPos, setFocusPos] = useState(null);
  const [language, setLanguage] = useState("PT");
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  const t = translations[language];

  // Carrega atletas da API
  async function fetchAtletas() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const res = await fetch(`${apiUrl}/scoring-last-segment`, {
      headers: { 'x-api-key': process.env.REACT_APP_API_KEY }
    });
    const data = await res.json();
    setHoraGun(data.horaGun || "2025-11-02 12:00:00");
    setAtletas(data.atletas || []);
    serverNow = data.serverNow || Date.now();
    //console.log("Atletas atualizados:", data.atletas);
    atletasRef.current = (data.atletas || []).map(a => ({
      ...a,
      hPassagemTimestamp: getTimestamp(a.h_passagem, data.horaGun || "2025-11-02 12:00:00"),
      lastUpdate: serverNow
    }));
  }

  useEffect(() => {
    fetchAtletas();
    const apiInterval = setInterval(fetchAtletas, 5000);

    const animInterval = setInterval(() => {
      setAnimados(atletasRef.current.map(a => {
        // Se o atleta concluiu a prova, não adiciona extraDistancia (para de se mover)
        if (atletaConcluiuProva(a)) {
          return { ...a, extraDistancia: 0 };
        }
        
        const agora = serverNow + (Date.now() - serverNow); // avança localmente
        const deltaSegundos = Math.max(0, (agora - a.hPassagemTimestamp) / 1000);
        //console.log("Atualizando atleta:", a.nome, "Delta segundos:", deltaSegundos);
        const velocidadeKmh = getVelocidade(a);
        const velocidadeMs = velocidadeKmh ? velocidadeKmh * 0.277778 : 7; // converter km/h para m/s (1 km/h = 0.277778 m/s)
        const extraDistancia = velocidadeMs * Math.max(0, deltaSegundos);
        return { ...a, extraDistancia };
      }));
    }, 200);

    return () => {
      clearInterval(apiInterval);
      clearInterval(animInterval);
    };
  }, []);

  // Atualiza atletasRef sempre que a API muda, usando horaGun do estado
  useEffect(() => {
    atletasRef.current = atletas.map(a => ({
      ...a,
      hPassagemTimestamp: getTimestamp(a.h_passagem, horaGun),
      lastUpdate: Date.now()
    }));
  }, [atletas, horaGun]);

  const [searchMsg, setSearchMsg] = useState("");

  function handleSearch(e) {
    e.preventDefault();
    const bib = searchBib.trim();
    if (!bib) return;
    const atleta = animados.find(a => String(a.bib) === bib);
    if (atleta) {
      if (atleta.status !== 0) {
        let msg = "";
        switch (atleta.status) {
          case 1: msg = t.statusUnknown; break;
          case 2: msg = t.statusDSQ; break;
          case 3: msg = t.statusDNF; break;
          case 4: msg = t.statusDNS; break;
          default: msg = t.statusUnknown;
        }
        setSearchMsg(msg);
        setFocusPos(null);
        return;
      }
      setSearchMsg("");
      const pos = calcularPosicao(atleta, atleta.extraDistancia);
      setFocusPos(pos);
    } else {
      setSearchMsg(t.notFound);
      setFocusPos(null);
    }
  }
  
const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div
      style={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        position: "relative"
      }}
    >
      <div
        style={{
          height: "100vh",
          width: sidebarOpen ? "320px" : "48px",
          background: "#fff",
          borderRight: "2px solid #078569",
          zIndex: 3000,
          display: "flex",
          flexDirection: "column",
          boxShadow: "2px 0 12px rgba(7,133,105,0.08)",
          padding: sidebarOpen ? "24px 16px 16px 16px" : "12px 6px",
          gap: 16,
          maxWidth: "90vw",
          minWidth: sidebarOpen ? "220px" : "48px",
          overflowY: "auto",
          transition: "width 0.25s, padding 0.25s"
        }}
      >
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        style={{
          position: "absolute",
          top: 12,
          left: 12,
          background: "transparent",
          color: "#078569",
          border: "none",
          borderRadius: "50%",
          width: 32,
          height: 32,
          fontSize: 26,
          cursor: "pointer",
          zIndex: 3100,
          boxShadow: sidebarOpen ? "0 2px 6px rgba(7,133,105,0.08)" : "none",
          transition: "background 0.2s"
        }}
        aria-label={sidebarOpen ? "Recolher" : "Expandir"}
      >
        {sidebarOpen ? "×" : "☰"}
      </button>
      <div style={{ marginTop: 44 }}>
        {sidebarOpen && (
          <>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8}}>
              <h2 style={{ color: "#078569", marginBottom: 12, fontWeight: 900, fontSize: 22 }}>{t.athletes}</h2>
              {/* Animação CSS inline para garantir que está disponível */}
              <style>{flagAnimStyle}</style>
              <button
                onClick={() => setLanguage(language === "PT" ? "EN" : "PT")}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  marginLeft: 8,
                  marginBottom: 8,
                  padding: 2,
                  borderRadius: 6,
                  transition: 'background 0.2s',
                  outline: 'none',
                  userSelect: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: 40,
                  minHeight: 40,
                  height: 40,
                  width: 40
                }}
                aria-label={language === "PT" ? "Switch to Portuguese | Mudar para Português" : "Mudar para Inglês | Switch to English"}
                title={language === "PT" ? "Switch to Portuguese | Mudar para Português" : "Mudar para Inglês | Switch to English"}
              >
                <img
                  src={language === "PT" ? gbFlag : ptFlag}
                  alt={language === "PT" ? "English" : "Português"}
                  style={{
                    width: 32,
                    height: 32,
                    objectFit: 'cover',
                    display: 'block',
                    borderRadius: '50%',
                    border: '1.5px solid #078569',
                    boxShadow: '0 0 0 0 rgba(7,133,105,0.15)',
                    animation: 'flag-pulse 1.8s cubic-bezier(.4,0,.6,1) infinite',
                    background: '#fff',
                  }}
                />
              </button>
            </div>
            <form
              onSubmit={handleSearch}
              style={{
                display: "flex",
                gap: 8,
                marginBottom: 18,
                alignItems: "center"
              }}
            >
              <input
                type="text"
                placeholder={t.searchBib}
                value={searchBib}
                onChange={e => setSearchBib(e.target.value)}
                style={{
                  flex: 1,
                  padding: "7px 12px",
                  border: "1px solid #078569",
                  borderRadius: 6,
                  outline: "none",
                  fontSize: 15,
                  color: "#078569",
                  background: "#fff"
                }}
              />
              <button
                type="submit"
                style={{
                  background: "#078569",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  padding: "7px 18px",
                  fontWeight: "bold",
                  fontSize: 15,
                  cursor: "pointer"
                }}
              >
                {t.focus}
              </button>
            </form>
            {searchMsg && (
              <div style={{
                background: "#fff",
                color: "#078569",
                border: "1px solid #078569",
                borderRadius: 6,
                padding: "8px 12px",
                fontWeight: "bold",
                marginBottom: 12,
                fontSize: 15
              }}>
                {searchMsg}
              </div>
            )}
            <div style={{ flex: 1, overflowY: "auto" }}>
              {animados
                .sort((a, b) => a.bib - b.bib)
                .map((atleta) => {
                  // Apenas alpha2: usa diretamente o valor de equipa se for 2 letras
                  function getAlpha2CountryCode(equipa) {
                    if (!equipa) return null;
                    const code = equipa.trim();
                    // Aceita alpha2 em maiúsculas ou minúsculas
                    if (/^[a-zA-Z]{2}$/.test(code)) return code.toLowerCase();
                    return null;
                  }
                  const countryCode = getAlpha2CountryCode(atleta.pais);
                  return (
                    <div
                      key={atleta.atleta_id}
                      style={{
                        borderBottom: "1px solid #eee",
                        padding: "10px 0",
                        cursor: "pointer",
                        transition: "background 0.2s",
                        background: searchBib && String(atleta.bib) === searchBib ? "#e6f7f3" : "#fff"
                      }}
                      onClick={() => {
                        setSearchBib(String(atleta.bib));
                        setSearchMsg("");
                        setFocusPos(calcularPosicao(atleta, atleta.extraDistancia));
                        if (window.innerWidth < 600 && sidebarOpen) {
                          setSidebarOpen(false);
                          setTimeout(() => {
                            setFocusPos(calcularPosicao(atleta, atleta.extraDistancia));
                          }, 300);
                        }
                      }}
                    >
                      <div style={{ fontWeight: 700, fontSize: 17, color: "#078569", display: 'flex', alignItems: 'center', gap: 8 }}>
                        {countryCode && (
                          <span style={{
                            width: 22,
                            height: 22,
                            display: 'inline-block',
                            background: 'transparent',
                            overflow: 'hidden',
                            marginRight: 2,
                            padding: 0
                          }}>
                            <img
                              src={`https://flagcdn.com/24x18/${countryCode}.png`}
                              alt={countryCode}
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'center',
                                display: 'block',
                                padding: 0,
                                margin: 0,
                                background: 'transparent'
                              }}
                            />
                          </span>
                        )}
                        {atleta.nome} <span style={{ color: "#333", fontWeight: 400, fontSize: 15 }}>#{atleta.bib}</span>
                      </div>
                      <div style={{ fontSize: 13, color: "#078569", marginTop: 2 }}>
                        {t.prova}: <span style={{ color: "#333", fontWeight: 600 }}>{atleta.descricaoProva}</span>
                      </div>
                      <div style={{ fontSize: 14, color: "#333", marginTop: 2 }}>
                        {(segmentNames[language][atleta.segmento_nome] || atleta.segmento_nome)} &nbsp;|&nbsp; {t.lap}: <span style={{ color: "#078569", fontWeight: 600 }}>{getVolta(atleta) === 'Transição' ? t.transition : getVolta(atleta)}</span>
                      </div>
                      <div style={{ fontSize: 13, color: "#666", marginTop: 2 }}>
                        {atleta.equipa}
                      </div>
                      {(atleta.PFinish || atletaConcluiuProva(atleta)) && (
                        <div style={{ fontSize: 13, color: "#078569", marginTop: 2 }}>
                          {atletaConcluiuProva(atleta) ? (
                            <span style={{ color: "#333", fontWeight: 600 }}>{t.completedRace}</span>
                          ) : (
                            <>
                              {t.finishTime}: <span style={{ color: "#333", fontWeight: 600 }}>
                                {atleta.PFinish}
                              </span>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </>
        )}
      </div>
    </div>
      <div
        style={{
          flex: 1,
          height: "100vh",
          minWidth: 0,
          transition: "width 0.25s"
        }}
      >
        <MapContainer
          center={percurso[0]}
          zoom={15}
          style={{
            height: "100vh",
            width: "100%",
            minWidth: 0,
            transition: "width 0.25s"
          }}
        >
          <ForceMapResize trigger={sidebarOpen} />
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />
  <Polyline positions={natacao} color="deepskyblue" />
  <Polyline positions={ciclismo} color="orange" />
  <Polyline positions={corrida} color="green" />

        {/* Marcadores de KM para Natação (a cada 1km) */}
        {pontosKmNatacao.map((ponto, index) => {
          const iconKmNatacao = L.divIcon({
            className: "km-marker-natacao",
            html: `<div style="
              width: 20px; height: 20px;
              background: #004E68;
              border: 2px solid #fff;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 9px;
              color: #fff;
              box-shadow: 0 2px 4px rgba(0,0,0,0.3);
            ">${ponto.km}</div>`,
            iconSize: [20, 20],
            iconAnchor: [10, 10],
          });
          
          return (
            <Marker key={`natacao-km-${index}`} position={ponto.posicao} icon={iconKmNatacao}>
              <Popup>
                <strong>Natação - {ponto.km} KM</strong>
              </Popup>
            </Marker>
          );
        })}

        {/* Marcadores de KM para Ciclismo (a cada 5km) */}
        {pontosKmCiclismo.map((ponto, index) => {
          const iconKmCiclismo = L.divIcon({
            className: "km-marker-ciclismo",
            html: `<div style="
              width: 24px; height: 24px;
              background: #ff6b35;
              border: 2px solid #fff;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 10px;
              color: #fff;
              box-shadow: 0 2px 4px rgba(0,0,0,0.3);
            ">${ponto.km}</div>`,
            iconSize: [24, 24],
            iconAnchor: [12, 12],
          });
          
          return (
            <Marker key={`ciclismo-km-${index}`} position={ponto.posicao} icon={iconKmCiclismo}>
              <Popup>
                <strong>Ciclismo - {ponto.km} KM</strong>
              </Popup>
            </Marker>
          );
        })}

        {/* Marcadores de KM para Corrida (a cada 1km) */}
        {pontosKmCorrida.map((ponto, index) => {
          const iconKmCorrida = L.divIcon({
            className: "km-marker-corrida",
            html: `<div style="
              width: 20px; height: 20px;
              background: #228B22;
              border: 2px solid #fff;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 9px;
              color: #fff;
              box-shadow: 0 2px 4px rgba(0,0,0,0.3);
            ">${ponto.km}</div>`,
            iconSize: [20, 20],
            iconAnchor: [10, 10],
          });
          
          return (
            <Marker key={`corrida-km-${index}`} position={ponto.posicao} icon={iconKmCorrida}>
              <Popup>
                <strong>Corrida - {ponto.km} KM</strong>
              </Popup>
            </Marker>
          );
        })}

        {focusPos && <FlyToAtleta pos={focusPos} />}
        {/* Polígono da zona de transição */}
        <Polygon positions={boundsTransicao} pathOptions={{ color: 'blue', weight: 2, fillOpacity: 0.19 }}>
          <Popup>{t.transition}</Popup>
        </Polygon>
         <Polygon positions={boundsTransicao2} pathOptions={{ color: 'blue', weight: 2, fillOpacity: 0.19 }}>
          <Popup>{t.transition}</Popup>
        </Polygon>
        <Polygon positions={boundsMeta} pathOptions={{ color: 'blue', weight: 2, fillOpacity: 0.19 }}>
          <Popup>{t.finish}</Popup>
        </Polygon>
        {animados.filter(atleta => atleta.status === 0)
        .map((atleta) => {
          const pos = calcularPosicao(atleta, atleta.extraDistancia);
          const volta = getVolta(atleta); // <-- aqui obtém a volta

          // ...existing code for icon...
          const icon = L.divIcon({
            className: "atleta-icon",
            html: `<div style="
              width:32px;height:32px;
              background:#fff;
              border:2px solid #333;
              border-radius:50%;
              display:flex;
              align-items:center;
              justify-content:center;
              font-weight:bold;
              font-size:12px;
              color:#333;
              box-shadow:0 2px 6px rgba(0,0,0,0.2);
            ">${atleta.bib}</div>`,
            iconSize: [35, 3],
            iconAnchor: [16, 16],
          });

          return (
            <Marker key={atleta.atleta_id} position={pos} icon={icon}>
              <Popup>
                <strong>{atleta.nome}</strong><br />
                {t.segment}: {(segmentNames[language][atleta.segmento_nome] || atleta.segmento_nome)}<br />
                {t.avgSpeed}: {getVelocidade(atleta)} km/h<br />
                {t.lap}: {volta === 'Transição' ? t.transition : volta}
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
    <div
  style={{
    position: "fixed",
    top: 18,
    right: 24,
    zIndex: 4000,
    background: "rgba(255,255,255,0.95)",
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(7,133,105,0.08)",
    padding: "6px 14px",
    display: "flex",
    alignItems: "center"
  }}
>
  <img
    src={logoFederacao}
    alt={t.ftp}
    style={{
      height: 38,
      width: "auto",
      objectFit: "contain"
    }}
  />
</div>

{/* Modal de Aviso */}
{showDisclaimer && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 5000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "16px",
      boxSizing: "border-box"
    }}
  >
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: 12,
        padding: "20px",
        maxWidth: "500px",
        width: "100%",
        maxHeight: "90vh",
        overflowY: "auto",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        border: "2px solid #078569",
        margin: "auto",
        boxSizing: "border-box"
      }}
    >
      <h3
        style={{
          color: "#078569",
          margin: "0 0 16px 0",
          fontSize: "18px",
          fontWeight: "bold",
          textAlign: "center",
          lineHeight: "1.3"
        }}
      >
        {t.disclaimerTitle}
      </h3>
      <p
        style={{
          color: "#333",
          margin: "0 0 20px 0",
          fontSize: "14px",
          lineHeight: "1.5",
          textAlign: "center"
        }}
      >
        {t.disclaimerText}
      </p>
      <div style={{ textAlign: "center" }}>
        <button
          onClick={() => setShowDisclaimer(false)}
          style={{
            background: "#078569",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            padding: "12px 24px",
            fontSize: "14px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "background 0.2s",
            minWidth: "120px"
          }}
          onMouseOver={(e) => e.target.style.background = "#065a4a"}
          onMouseOut={(e) => e.target.style.background = "#078569"}
        >
          {t.closeDisclaimer}
        </button>
      </div>
    </div>
  </div>
)}
  </div>
);
}